module.exports = __webpack_public_path__ + "img/1.a38bbd96.png";